import { afterNextRender, Component, forwardRef, input, linkedSignal, output, signal } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CSSValuePipe } from '@pipes/css-value-pipe';
import { AbstractControl } from '../abstract-control/abstract-control';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [MatTooltipModule, CSSValuePipe],
  templateUrl: './checkbox.html',
  styleUrl: './checkbox.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Checkbox),
      multi: true,
    },
  ],
})
export class Checkbox extends AbstractControl<boolean | undefined, boolean> {
  // Inputs
  override $value = input<boolean | undefined>(undefined, { alias: 'value' });
  $_value = linkedSignal(this.$value);

  // Outputs
  override valueChange = output<boolean>();

  // Signals / atributos
  override $controlValue = signal<boolean>(false);

  // Verificar si se emitirá el valor al iniciar
  constructor() {
    super();
    afterNextRender(() => {
      if (this.$emitAtStart()) {
        const value = (this.$value() !== undefined ? this.$value() : this.$controlValue()) as boolean;
        this.valueChange.emit(value);
      }
    });
  }

  // Maneja el evento de cambio de valor desde el input
  onValueChange(event: Event) {
    const newValue: boolean = (event.target as HTMLInputElement).checked;
    if (this.$value() !== undefined)
      this.$_value.set(undefined);
    this.updateValue(newValue);
    this.valueChange.emit(newValue);
  }
}
